@if (compact) {
  <div ngbDropdown #appearanceMenu="ngbDropdown" placement="bottom-end" [autoClose]="true">
    <button #appearanceTrigger type="button" ngbDropdownToggle class="appearance-menu__trigger"
      [id]="groupName + '-trigger'">
      <i class="pi pi-palette" aria-hidden="true"></i>
      <span>Appearance</span>
    </button>
    <div ngbDropdownMenu class="appearance-menu__panel" tabindex="-1" [attr.aria-labelledby]="groupName + '-trigger'"
      (click)="appearanceMenu.close(); appearanceTrigger.focus()"
      (keydown.enter)="appearanceMenu.close(); appearanceTrigger.focus()">
      <appearance-toggle [preference]="preference" [labelledBy]="groupName + '-trigger'"
        (preferenceChange)="preferenceChange.emit($event); appearanceMenu.close(); appearanceTrigger.focus()"></appearance-toggle>
    </div>
  </div>
} @else {
<div class="appearance-toggle" role="radiogroup" [attr.aria-labelledby]="labelledBy"
  [attr.aria-label]="labelledBy ? null : 'Appearance'">
  @for (option of options; track option.id) {
    <!-- Keep the input above the whole card: Bootstrap leaves dropdowns open when a radio is selected. -->
    <label class="appearance-toggle__option" [class.appearance-toggle__option--active]="preference === option.id">
      <input type="radio" class="appearance-toggle__input" [name]="groupName" [value]="option.id"
        [checked]="preference === option.id" (change)="preferenceChange.emit(option.id)">
      <span class="appearance-toggle__preview" [attr.data-app-theme-preview]="option.palette" aria-hidden="true">
        <span class="appearance-toggle__preview-sidebar">
          <span class="appearance-toggle__preview-brand"></span>
          <span class="appearance-toggle__preview-nav appearance-toggle__preview-nav--active"></span>
          <span class="appearance-toggle__preview-nav"></span>
          <span class="appearance-toggle__preview-nav"></span>
        </span>
        <span class="appearance-toggle__preview-main">
          <span class="appearance-toggle__preview-heading"></span>
          <span class="appearance-toggle__preview-cards">
            <span></span><span></span>
          </span>
          <span class="appearance-toggle__preview-table">
            <span></span><span></span><span></span>
          </span>
        </span>
        @if (preference === option.id) {
          <span class="appearance-toggle__check"><i class="pi pi-check"></i></span>
        }
      </span>
      <span class="appearance-toggle__details">
        <span class="appearance-toggle__name">{{option.label}}</span>
        <span class="appearance-toggle__description">{{option.description}}</span>
      </span>
    </label>
  }
</div>
}
